var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 30.1",
    style: {
      enableBackground: "new 0 0 27 30.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E2224;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,25.8l0.8,0.8c0.5-0.5,0.5-1.2,0-1.6L25.8,25.8z M7.3,3.1c-0.6,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2V3.1 L7.3,3.1z M23.6,21.9c-0.5-0.5-1.2-0.5-1.6,0s-0.5,1.2,0,1.6L23.6,21.9z M21.9,28.1c-0.5,0.5-0.5,1.2,0,1.6s1.2,0.5,1.6,0 L21.9,28.1z M25.8,24.7H6.6V27h19.3L25.8,24.7L25.8,24.7z M6.6,16.2h13.9v-2.3H6.6V16.2z M20.4,3.1H7.3v2.3h13.1 C20.4,5.4,20.4,3.1,20.4,3.1z M26.7,25l-3.1-3.1l-1.6,1.6l3.1,3.1L26.7,25z M25,25l-3.1,3.1l1.6,1.6l3.1-3.1L25,25z M27,9.6 c0-3.6-2.9-6.6-6.6-6.6v2.3c2.3,0,4.2,1.9,4.2,4.2L27,9.6L27,9.6z M20.4,16.2c3.6,0,6.6-2.9,6.6-6.6h-2.3c0,2.3-1.9,4.2-4.2,4.2 L20.4,16.2L20.4,16.2z M2.3,20.4c0-2.3,1.9-4.2,4.2-4.2v-2.3c-3.6,0-6.6,2.9-6.6,6.6L2.3,20.4L2.3,20.4z M6.6,24.7 c-2.3,0-4.2-1.9-4.2-4.2H0C0,24.1,2.9,27,6.6,27V24.7L6.6,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.2,8.5C1.9,8.5,0,6.6,0,4.2S1.9,0,4.2,0s4.2,1.9,4.2,4.2S6.6,8.5,4.2,8.5L4.2,8.5z M4.2,2.3 c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9S5.3,2.3,4.2,2.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.eb54344b87eb61f1720aebe9c14c55f7.svg";
export { ForwardRef as ReactComponent };